export default __webpack_public_path__ + "static/test_tom_5-233075fe14797f32856f77fa7ffa04a0.png";